<template>
  <div class='mb25 s_flex_ali' v-if='data.length < 3'>
    <span class='mr15'>
      <a-button type="primary" v-has:storeLevelCreate="()=>addlevel('add')">
        <PlusOutlined />
        添加级别
      </a-button>
    </span>
    <p class="s_fonts16 s_c333">警告：不同门店级别一经启用，请不要随意修改！最多添加3个级别</p>
  </div>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
    <template v-slot:manage="{ record }">
      <span class="m-r-20">添加门店：
        <CheckOutlined v-if='record.is_can_add' />
        <CloseOutlined v-else />
      </span>
      <span>删除门店：
        <CheckOutlined v-if='record.is_can_del' />
        <CloseOutlined v-else />
      </span>
    </template>
    <template v-slot:action="{ record }">
      <a v-has:storeLevelEdit="()=>addlevel(record)" href="javascript:;">修改</a>
    </template>
  </a-table>
  <a-modal  :keyboard="false" :title="type=='edit'?'编辑级别':'添加级别'" :width='1000' centered :footer="null" v-model:visible="visible"
    destroyOnClose>
    <levelAdd v-on:settype='settype' v-on:onsubmit='onsubmit' :formData='formData' :formType='type'></levelAdd>
  </a-modal>
</template>
<script>
  import { DownOutlined, PlusOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getLevelList, levelDel } from "@/api/store";
  import { iscode } from "@/utils/app";
  import levelAdd from './level_add';
  let defSearch = {
    page: 1,
    limit: 10
  };
  export default {
    components: {  PlusOutlined, levelAdd, CheckOutlined, CloseOutlined },
    name: 'levelList',
    setup(props, { emit }) {
      // 列表数据和列头配置
      let data = ref([]);
      const search = ref({ ...defSearch });
      const state = reactive({
        type: 'add',
        formData: {},
        visible: false,
        listLoading: false,
        total: 1
      });
      let columns = [
        {
          title: "门店等级",
          dataIndex: "level",
          key: "level",
        },
        {
          title: "等级名称",
          dataIndex: "level_name",
          key: "level_name",
        },
        {
          title: "需成长值达",
          dataIndex: "growth_value",
          key: "growth_value",
        },
        // {
        //   title: "门店管理",
        //   key: "manage",
        //   slots: { customRender: "manage" },
        // },
        {
          title: "门店数量",
          dataIndex: "store_num",
          key: "store_num",
        },
        {
          title: "备注",
          dataIndex: "remarks",
          key: "remarks",
          customRender: ({ text,record }) => {
              return record.remarks ?record.remarks:'-'
          },
        },
        {
          title: "操作",
          key: "action",
          width:120,
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      //删除等级
      const delLevel = (e) => {
        $Modal.confirm({
          centered:true,
          title: '删除门店等级',
          content: '删除后该等级将无法恢复，您确定要删除该门店等级吗？', onOk: async () => {
            let res = await levelDel({ id: e.id }).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      //添加/编辑
      const addlevel = (e) => {
        if (e == 'add') {
          state.visible = true
          state.formData = {}
          state.type = 'add'
        } else {
          state.visible = true
          state.formData = e
          state.type = 'edit'
        }
      }
      const onsubmit =  () => {
        state.visible = false
        state.type == 'add'
        initData(search.value);
      }
      const initData = async (values) => {
        state.listLoading = true;
        data.value = []
        try {
          let res = await getLevelList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      const settype = (type) => {
        state.visible = false
        emit("gopage", type);
      }

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        columns,
        delLevel,
        settype,
        onsubmit,
        addlevel
      };
    },
  };
</script>